import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from 'lodash';
import {getCorrectAnswerCount} from '../../../../../../store/reducers/questions/correctAnswers';
import {getQuestionResults, QuestionResult} from '../../../../../../data/data';

interface Props
{
    correct_answer_count: number;
}

import './ScoreSection.scss';


class QuestionSection extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    getResult = () =>
    {
        const {correct_answer_count} = this.props;

        const data: QuestionResult[] = getQuestionResults();

        return _.find(data, result => correct_answer_count <= result.correct);
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {correct_answer_count = 0} = this.props;
        const result: QuestionResult = this.getResult();


        const text: string = result.text.replace('$questions', correct_answer_count.toString());

        return <div styleName={'score-section'}>

            <div styleName={'copy'} dangerouslySetInnerHTML={{ __html: text }}/>



            {/*<span styleName={'highlight'}>

                <HighlightText type={'blue'}>time's up!</HighlightText>

            </span>
            <h3 styleName={'result-text'}>Well done! You answered</h3>

            <h4 styleName={'correct-answer-count'}>{correct_answer_count}</h4>
            <p styleName={'result-text'}>questions correctly</p>*/}

            {/*<Button
                type={'submit-score'}
                onClick={this.submitScore}>submit score</Button>*/}

        </div>;
    }
}


const mapStateToProps = state =>
{
    return {
        correct_answer_count: getCorrectAnswerCount(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionSection);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/game-over/hints/QuestionsSection.tsx